import React from "react";
import { createPortal } from "react-dom";
import theme from "../../../styles/theme";

const TreeContextMenu = ({ x, y, visible, node, onClose, onAction }) => {
  if (!visible || !node) return null;

  return createPortal(
    <div
      style={{
        position: "fixed",
        top: y,
        left: x,
        zIndex: 99999,
        background: theme.colors.background.surface,
        border: `1px solid ${theme.colors.borders.default}`,
        borderRadius: 6,
        minWidth: 180,
        boxShadow: "0px 4px 16px rgba(0,0,0,0.25)",
        padding: 4,
        animation: "fadeIn 0.1s ease",
        userSelect: "none",
      }}
      onMouseLeave={onClose}
    >
      {/* SECTION : Structure */}
      <div style={sectionTitle}>Structure</div>

      <div style={itemStyle} onClick={() => onAction("add-child", node)}>
        ➕ Ajouter un enfant
      </div>

      <div style={itemStyle} onClick={() => onAction("add-sibling", node)}>
        ➕ Ajouter un voisin
      </div>

      <div style={itemSeparator} />

      {/* SECTION : Déplacements */}
      <div style={sectionTitle}>Déplacement</div>

      <div style={itemStyle} onClick={() => onAction("move-up", node)}>
        ▲ Monter
      </div>

      <div style={itemStyle} onClick={() => onAction("move-down", node)}>
        ▼ Descendre
      </div>

      <div style={itemStyle} onClick={() => onAction("indent", node)}>
        ▶️ Indenter (devient enfant du précédent)
      </div>

      <div style={itemStyle} onClick={() => onAction("outdent", node)}>
        ◀️ Désindenter (remonter d’un niveau)
      </div>

      <div style={itemSeparator} />

      {/* SECTION : Gestion */}
      <div style={sectionTitle}>Gestion</div>

      <div style={itemStyle} onClick={() => onAction("rename", node)}>
        ✏️ Renommer
      </div>

      <div
        style={{ ...itemStyle, color: theme.colors.text.danger }}
        onClick={() => onAction("delete", node)}
      >
        🗑️ Supprimer
      </div>
    </div>,
    document.body
  );
};

// ============================================================================
// Styles
// ============================================================================

const itemStyle = {
  padding: "6px 12px",
  cursor: "pointer",
  fontSize: 13,
  borderRadius: 4,
  whiteSpace: "nowrap",
  transition: "background 0.1s",
  color: theme.colors.text.body,
};

const sectionTitle = {
  padding: "4px 10px 2px",
  fontSize: 11,
  color: theme.colors.text.verysmall,
  textTransform: "uppercase",
};

const itemSeparator = {
  height: 1,
  margin: "4px 0",
  background: theme.colors.borders.default,
  opacity: 0.5,
};

export default TreeContextMenu;
